import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { AdvancedReorderItem } from "../advanced-reorder-item";
import { AdvancedReorderHelper } from "../advanced-reorder-helper";

@Component({
  selector: 'monthly-picker',
  templateUrl: './monthly-picker.component.html',
  styleUrls: ['./monthly-picker.component.scss']
})
export class MonthlyPickerComponent {
  @Input() helper: AdvancedReorderHelper;
  @Input() item: AdvancedReorderItem;
}